export default __webpack_public_path__ + "static/media/linkedin.69bcb3be.svg";